import React, { useState, useEffect } from 'react'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import { logout } from '../../../../action/auth-actions'
import { connect } from 'react-redux'
import moment from 'moment'
import Edit from '../../../main-ui/right-toolbar/profile/edit/index'
import EditPassword from '../../../main-ui/right-toolbar/profile/edit/edit-password'
import './index.css'
import ProIcon from '../../../../../asset/pro-icon.png'
import { photoUploadRequest } from '../../../../action/photo-actions'
import { userUpdateRequest } from '../../../../action/user-actions'
import ProfileIcon from '../../../../../asset/default-profile.png'
import SplashScreenLoader from '../../../../../asset/loading-spinner.gif'
import CancelSubscription from './cancelRenewal'
import { cancelUserSubscription } from '../../../../action/user-actions'
import { showHideSubscriptionModal } from '../../../../utils/subscriptionUtils'
import { locationClearTimeOut } from '../../../../action/friends-location-action'
import UpgradeSubscription from './upgradeModelPopup'

const Profile = (props) => {
  const [editProfile, setEditProfile] = useState(true)
  const [editPassword, setEditPassword] = useState(false)
  const [loadSpinner, setLoadSpinner] = useState(false)
  const [cancelSubscription, setCancelSubscription] = useState(false)
  const [subscriptionPlanIdState, setsubscriptionPlanIdState] = useState()
  const [imageValue, setImageValue] = useState(props.user.imageProfileUrl ? props.user.imageProfileUrl : ProfileIcon)

  const [modelVisible, setModelVisible] = useState(false)
  let inputEle = React.createRef()
  const { hidePopout, expandRightToolbar, collapseLeftToolbar, user, logout, subscriptionPlans, locationTimeInterval, locationClearTimeOut } = props,
    userImage = user.imageProfileUrl ? user.imageProfileUrl : '../../../../asset/default-profile.png',
    basicPlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 1),
    proPlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 4),
    proBundlePlan = user.userSubscription.find(plan => plan.subscriptionPlanId === 44)

  useEffect(() => {
    // setImageValue(user.imageProfileUrl)
    getProfileIcon(user.imageProfileUrl)
  }, [user])


  useEffect(() => {
    imageValue && setTimeout(() => {
      setLoadSpinner(false)
    }, 1500)
  }, [imageValue])

  let subValue = user.userSubscription.map(items => {
    let values = []
    let filterValue = subscriptionPlans.filter(value => {
      if (items.subscriptionPlanId == value.id) {
        values.push({ userSubscription: items, subscriptionPlan: value })
      }
    })
    return values
  })
  let updatePhoto = (e) => {
    e.preventDefault()
    inputEle.current.click()
  }

  let logoutFunction = (e) => {
    logout()
    // locationTimeInterval
    console.log('helo stopped')
    if (locationTimeInterval) {
      clearInterval(locationTimeInterval);
      // this.timeInterval = null;
      locationClearTimeOut(null)
    }
  }

  let handlePhotoUpload = (e) => {
    const { photoUploadRequest, userUpdateRequest, user } = props,
      file = e.target.files[0]
    setLoadSpinner(true)
    if (file) {
      let data = new FormData()
      data.append('file', file)
      let photoInfo = {
        typeId: 2,
        activityId: 1
      }
      photoInfo = JSON.stringify(photoInfo)
      data.append('photoInfo', photoInfo)
      photoUploadRequest(data).then(res => {
        let userInfo = Object.assign({}, user)
        userInfo.photoId = res.id
        delete userInfo.password
        userUpdateRequest(userInfo)
          .then(() => {
            console.log('User Photo Updated')
          })
          .catch((err) => {
            setLoadSpinner(false)
            console.error('User Photo Update Failed: ', err)
          })
      })
    }
  }
  let cancelRenewal = (subscriptionPlanId) => {
    setCancelSubscription(true)
    setsubscriptionPlanIdState(subscriptionPlanId)
  }

  let cancelSubscriptionfunction = () => {
    props.cancelUserSubscription(subscriptionPlanIdState, (res) => {
      if (res.statusCode == 1000) {
        setCancelSubscription(false)
      } else if (res.statusCode == 8888) {
        setCancelSubscription(false)
        alert('Subscrition renewal cancel is not cancelled')
      }
    });
  };

  let getProfileIcon = (imageUrl) => {
    let userImageVal
    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      userImageVal = img.src;
      setImageValue(userImageVal)
      return userImageVal
    };

    img.onerror = () => {
      userImageVal = '../../../../asset/default-profile.png';
      setImageValue(userImageVal)
      return userImageVal
    };
  }

  return (
    <div className='left-expanded-profile-container'>
      {editProfile ? <>
        <div style={{ width: 440 - 78, height: '100vh', boxSizing: 'border-box', display: 'flex', flexWrap: 'wrap', transition: 'width 1s ease' }}>
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className='left-expanded-header-container'>
              <span className='left-expanded-header'>My Account</span>
              <div className='default-close left-dialog-close' onClick={collapseLeftToolbar}></div>
            </div>
            <div className="parent-grid-container">
              <div className="grid-container">
                <div className="grid-item">
                  <div className='left-extended-profile'>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <div style={{ position: 'relative', border: '3px solid #6E6E6E', width: 100, height: 100, borderRadius: '50%', marginTop: 10, marginBottom: 10 }}>
                        {/* Overlay Icon */}
                        {user.isPro &&
                          <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <img src={ProIcon} style={{ position: 'absolute', bottom: -14, width: 42, height: 34, zIndex: 2 }} alt='Pro Icon' />
                          </div>}
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                          {loadSpinner && (
                            <div
                              style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                color: 'white',
                                zIndex: 1
                              }}
                            >
                              {/* Add your loader component here */}
                              <img src={SplashScreenLoader} style={{ width: '30px', height: '30px' }}></img>
                            </div>
                          )}
                          <img
                            // src={imageValue ? imageValue : userImageUrl}
                            src={imageValue}
                            style={{
                              width: 100,
                              height: 100,
                              borderRadius: '50%',
                              filter: loadSpinner ? 'blur(1px)' : 'none',
                            }}
                            alt="Profile Image"
                          />
                        </div>
                      </div>
                    </div>
                    <div className='profile-image-upload-container'>
                      <p style={{ textDecoration: 'underline', cursor: 'pointer', userSelect: 'none' }} onClick={updatePhoto}>Change Image</p>
                      <input type='file' accept='image/*' ref={inputEle} style={{ display: 'none' }} onChange={handlePhotoUpload}></input>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <h1 className="profile-text">{user.fullName}</h1>
                      <p className="profile-text">{user.email}</p>
                      <p className="profile-text-grey">Member since&nbsp;:&nbsp;{moment(user.created).format('MM-DD-YYYY')}</p>
                      <p className="profile-text-grey">{user.phone}</p>
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: 20 }}>
                      <a href="#" class="edit-profile-btn" style={{}} onClick={() => setEditProfile(false)}>
                        <p className='edit-profile-button-text'>EDIT PROFILE</p>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="grid-item"></div>
                <div className="grid-item">
                  <div className='left-toolbar-profile-container'>
                    <div style={{ width: '100%', height: 10 }}></div>
                    <div class="card-header">
                      <p style={{ font: 'normal normal normal 20px/26px Roboto', textAlign: 'center' }}> Memberships</p>
                    </div>

                    {__NODE_ENV__ != 'production' && subValue.length > 1 && <>
                      {subValue[subValue.length - 1][0].subscriptionPlan.id != 44 && <div className='upgrade-membership-container'>
                        <div className='active-subscription-container'>
                          <div className='item-style'>
                            <p className='text-style-update'
                            //  style={{ marginLeft: 15, font: 'normal normal normal 0.8125rem/1.25rem Roboto', color: '#FFFFFF' }}
                            >Active Plan: </p>
                          </div>
                          <div className='item-style-two'>
                            {/* <p>{subValue[subValue.length - 1][0].subscriptionPlan.name}</p> */}

                            <p>{subValue[subValue.length - 1][0].subscriptionPlan.name === "Pro Bundle" ? 'Pro Ultimate' : subValue[subValue.length - 1][0].subscriptionPlan.name}</p>
                          </div>
                        </div>

                        -------------------------------


                        <div className='active-subscription-container'>
                          <div className='item-style'>
                            <p className='text-style-update'
                            //  style={{ font: 'normal normal normal 0.8125rem/1.25rem Roboto', color: '#FFFFFF' }}
                            >Upgrade to Pro {subValue[subValue.length - 1][0].subscriptionPlan.id == 36 ? 'Ultimate' : 'Advantage / Ultimate'}</p>
                          </div>
                          <div className='item-style-two'>
                            <button className='membership-update-button'
                              // onClick={() => { showHideSubscriptionModal(props.auth.token) }}

                              onClick={() => { setModelVisible(!modelVisible) }}
                            >UPGRADE</button>
                          </div>
                        </div>


                        -------------------------------
                      </div>}

                      {
                        modelVisible &&
                        <UpgradeSubscription cancel={() => { setModelVisible(!modelVisible) }} currentSubscription={subValue[subValue.length - 1][0].subscriptionPlan.id} subscriptionName={subValue[subValue.length - 1][0].subscriptionPlan.name}></UpgradeSubscription>
                      }
                    </>}
                    <div style={{ display: 'flex', justifyContent: 'center', width: "100%", paddingBottom: 20 }}>
                      <table className='table-profile'>
                        <>{subValue.length > 1 ?
                          <>
                            {subValue.map((item) => {
                              return (
                                <>
                                  {item && item[0] && item[0].subscriptionPlan.id != 1 ?
                                    <div className='table-container'>
                                      <tr>
                                        <td className='td-profile-name'>{item[0].subscriptionPlan.name === "Pro Bundle" ? 'Pro Ultimate' : item[0].subscriptionPlan.name}</td>
                                        {!item[0].userSubscription.cancelDate && <td className='td-profile-exp'>
                                          <p style={{ fontSize: 12 }}>Renews:&nbsp;</p>
                                          <p style={{ fontSize: 12 }}>{moment(item[0].userSubscription.expDate).format('MM-DD-YYYY')}</p>
                                        </td>}
                                      </tr>
                                      <tr>
                                        <td className='td-profile-created-on'>Created on: {item[0].userSubscription.platformId === 1 ? 'Android' : item[0].userSubscription.platformId === 2 ? 'iOS' : item[0].userSubscription.platformId === 3 ? 'Web' : item[0].userSubscription.platformId >= 4 ? 'Other' : 'Other'}</td>
                                        {item[0].userSubscription.platformId === 3 && !item[0].userSubscription.cancelDate ?
                                          <td className='td-profile'>
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }} onClick={() => { cancelRenewal(item[0].userSubscription.id) }}>
                                              <a href="#" class="edit-profile-btn" style={{ width: '100px', height: '20px', }}>
                                                Cancel Renewal
                                              </a>
                                            </div>
                                          </td>
                                          : item[0].userSubscription.cancelDate &&
                                          <td className='td-profile'>
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 130 }} >
                                              <p style={{ fontSize: 12 }}>Expires on:&nbsp;</p>
                                              <p style={{ fontSize: 12 }}>{moment(item[0].userSubscription.cancelDate).format('MM-DD-YYYY')}</p>
                                            </div>
                                          </td>
                                        }
                                      </tr>
                                    </div>
                                    : ' '}
                                </>
                              )
                            })}
                          </>
                          :
                          <div className='no-membership-container'>
                            <h3>No Memberships</h3>
                            <button className='membership-upgeade-button'
                              onClick={() => { showHideSubscriptionModal(props.auth.token) }}
                            >UPGRADE</button>
                          </div>
                        }
                        </>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="grid-item update-psd-logout-button">
                  <div>
                    <a> <p style={{ textDecoration: 'underline' }} onClick={() => {
                      setEditPassword(true)
                      setEditProfile(false)
                    }}>Update Password</p></a>
                  </div>
                </div>
              </div>
            </div>
            <div className='container-profile'>
              <div className='logout-button-container'>
                <button className='logout-button' onClick={logoutFunction}>Logout</button>
              </div>
            </div>
          </div>
        </div>
      </> :
        editPassword ?
          <EditPassword fromLeftBar={true} cancelEdit={() => {
            setEditPassword(false)
            setEditProfile(true)
          }} ></EditPassword>
          :
          <Edit cancelEdit={() => {
            setEditProfile(true)
          }} />
      }
      {cancelSubscription &&
        <>
          <CancelSubscription
            remove={() => cancelSubscriptionfunction()}
            cancel={() => setCancelSubscription(false)}>
          </CancelSubscription>
        </>
      }
    </div>
  )
}

const mapStateToProps = state => ({
  user: state.user,
  subscriptionPlans: state.subscriptionPlans,
  auth: state.auth,
  locationTimeInterval: state.locationTimeInterval
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  logout: () => dispatch(logout()),
  expandRightToolbar: props => dispatch(expandRightToolbar(props)),
  photoUploadRequest: data => dispatch(photoUploadRequest(data)),
  userUpdateRequest: data => dispatch(userUpdateRequest(data)),
  cancelUserSubscription: (data, cb) => dispatch(cancelUserSubscription(data, cb)),
  locationClearTimeOut: (payload) => dispatch(locationClearTimeOut(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile)